module.exports = __webpack_public_path__ + "img/default.48175da9.png";